import { render, staticRenderFns } from "./BookingDetails.vue?vue&type=template&id=4e39fc2a&scoped=true&"
import script from "./BookingDetails.vue?vue&type=script&lang=js&"
export * from "./BookingDetails.vue?vue&type=script&lang=js&"
import style0 from "./BookingDetails.vue?vue&type=style&index=0&id=4e39fc2a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e39fc2a",
  null
  
)

export default component.exports